import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export const useOrderHeadersStore = defineStore('orderHeaders', () => {
  // state
  const refreshHeaders = useLocalStorage<string>('refresHeaders', '');

  // actions
  function setRefreshHeaders() {
    refreshHeaders.value = new Date().getTime().toString();
  }

  function $reset() {}

  return { refreshHeaders, setRefreshHeaders, $reset };
});
